export default "__VITE_ASSET__Bv1UCne2__"